export class FeatureFlagUtils {
  static isQuoteGenerationEnabled(): boolean {
    return false;
  }
}